const SDK_VERSION = '7.68.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
